import React  from 'react'

import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import CustomView_rowComponent from "./row-component"

import SelectTaskType from "../../../../../../../core/gd-ui/select-task-type/select-task-type"

type Props = {
    form                : FormManager
    formFieldName       : string
    allowedTaskTypes    : ID[]

    disabled?           : boolean
}

// const debug = "SelectTaskTypeMulti"
const debug = false

export default function SelectTaskTypeMulti(props: Props) {

    const values = props.form.getValue(props.formFieldName)
    const allowedTaskTypes = _.union(values, props.allowedTaskTypes)

    debug && console.log(debug, 'render', values, props.allowedTaskTypes, allowedTaskTypes)

    return (
        <CustomView_rowComponent label="Task types">
            <SelectTaskType form                = {props.form}
                            name                = {props.formFieldName}
                            multiselect         = {true}
                            taskTypesIds        = {allowedTaskTypes} // to show all task types, event deleted ones if any
                            allowedTaskTypes    = {allowedTaskTypes}
                            renderValue         = "form"
                            underlined          = "always"
                            placeholder         = "All task types"
                            canHaveNoValue      = {true}
                            noValueValue        = {[]}
                            noValueLabel        = "All task types"
                            disabled            = {props.disabled}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}

SelectTaskTypeMulti.defaultProps = {
    formFieldName   : "taskTypes",
}